<template>
  <div>
    <div class="cml-result-dialog">
      <span v-if="showText" class="success">
        成功:
        <i>{{ dialogResult.successNum }}条</i>
      </span>
      <span v-if="showText" class="fail">
        失败:
        <i>{{ dialogResult.failNum }}条</i>
      </span>
      <el-table
        v-if="dialogResult[tableDataField]"
        :data="dialogResult[tableDataField]"
        border
        height="450"
        size="mini"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column
          :label="tableLable"
          prop="code"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-if="showNameCol"
          label="产品名称"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="失败原因"
          prop="msg"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showText: {
      type: Boolean,
      default: true,
    },
    dialogResult: {
      type: Object,
    },
    tableDataField: {
      type: String,
      default: 'failOrderResultList',
    },
    tableLable: {
      type: String,
      default: '产品ID',
    },
    showNameCol: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.cml-result-dialog {
  .success {
    margin-right: 20px;
    i {
      color: #67c23a;
    }
  }
  .fail {
    i {
      color: #AB0033;
    }
  }
}
</style>